import type { ReactNode } from 'react';

export const symbol_gif_box: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M493-366.8q7-6.8 7-17.2v-192q0-10.4-7-17.2-7-6.8-17-6.8t-17 6.8q-7 6.8-7 17.2v192q0 10.4 7 17.2 7 6.8 17 6.8t17-6.8ZM274-360h84q14.45 0 24.23-9.77Q392-379.55 392-394v-62q0-10.4-7-17.2-7-6.8-17-6.8t-17 6.8q-7 6.8-7 17.2v48h-56v-144h80q10.4 0 17.2-7 6.8-7 6.8-17t-6.8-17q-6.8-7-17.2-7h-94q-14.45 0-24.23 9.78Q240-580.45 240-566v172q0 14.45 9.77 24.23Q259.55-360 274-360Zm327-6.8q7-6.8 7-17.2v-60h46q10.4 0 17.2-7 6.8-7 6.8-17t-6.8-17q-6.8-7-17.2-7h-46v-60h88q10.4 0 17.2-7 6.8-7 6.8-17t-6.8-17q-6.8-7-17.2-7H584q-10.4 0-17.2 6.8-6.8 6.8-6.8 17.2v192q0 10.4 7 17.2 7 6.8 17 6.8t17-6.8ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0 0v-600 600Z"
		/>
	</svg>
);
